import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import useModal from 'ui/partials/Modal/useModal';
import { useProvider } from 'utils/providers/Provider';
import partialConstants from 'ui/partials/utils/constants';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';

export default function useDeleteDeal() {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: { id?: string; pipelineId?: string }) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `/api/v1/sales/deals/${payload.id}`,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals/${payload.id}`,
          },
        }),
      );

      return data;
    },
    onSuccess: (_, payload) => {
      hideModal();

      queryClient.invalidateQueries([c.PIPELINES, payload.pipelineId, c.DEALS]);
      queryClient.invalidateQueries([c.DEALS, {}]);
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.COMPANIES],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      toastSuccess('Successfully deleted deal.');
    },
  });
}
